function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FormTable({ data = {} }) {
    const { rows = [], header = [], widths = [] } = data;
    return /*#__PURE__*/ _jsxs("table", {
        style: styles.table,
        children: [
            /*#__PURE__*/ _jsx("thead", {
                children: /*#__PURE__*/ _jsx("tr", {
                    children: header.map((header, index)=>/*#__PURE__*/ _jsx("th", {
                            style: _object_spread_props(_object_spread({}, styles.th), {
                                width: widths[index]
                            }),
                            children: header
                        }, `header_index_${index}`))
                })
            }),
            /*#__PURE__*/ _jsx("tbody", {
                children: rows.map((row, rowIndex)=>/*#__PURE__*/ _jsx("tr", {
                        children: row.map((item, columnIndex)=>/*#__PURE__*/ _jsx("td", {
                                style: styles.td,
                                colSpan: item.span,
                                children: item.element
                            }, `row_index_${rowIndex}_col_index_${columnIndex}`))
                    }, `row_index_${rowIndex}`))
            })
        ]
    });
}
const styles = {
    table: {
        display: "table",
        width: "100%",
        // border
        borderCollapse: "collapse",
        borderSpacing: "0px",
        border: "solid gray 1px",
        borderRadius: "4px",
        WebkitBorderRadius: "4px",
        MozBorderRadius: "4px",
        // font
        textAlign: "left",
        fontWeight: 400,
        fontSize: "0.9rem"
    },
    th: {
        padding: "4px",
        backgroundColor: "#e0e0e0",
        border: "solid gray 1px"
    },
    td: {
        border: "solid gray 1px",
        padding: "0 4px"
    },
    firstColumn: {
        borderLeft: "none"
    }
};
